/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { find } from 'lodash-es'
import { MenuItem, Stack, Typography } from '@mui/material'
import { useResultsInvalidation } from '@editor/hooks'
import { useModelStore } from '@editor/stores'
import { useMutation } from '@tanstack/react-query'
import { SaveButton } from '@ui/actions'
import { Form2, Label, Select, SubmitButton } from '@ui/forms'
import { enqueueSnackbar } from '@ui/snackbar'
import { getModel, getAssemblyAssignment, getElementCrossSectionAssignment } from '@queries'
import { updatePlacementMultipleWalls, updateWall } from '@mutations'
import client from 'src/state/client'

type DefaultValues = {
  placement: WallPlacement
}

const defaultValues: DefaultValues = {
  placement: 'Internal',
}

interface Props {
  elementGuids: string[]
}

const WallPlacement = ({ elementGuids }: Props) => {
  const { projectId } = useParams()

  const invalidateResults = useResultsInvalidation()

  const { mutate, isLoading } = useMutation({
    mutationFn: ({ placement }: DefaultValues) => {
      return updatePlacementMultipleWalls.request(projectId, elementGuids, placement)
    },
    onSuccess: () => {
      client.invalidateQueries(getModel.getKey(projectId))
      client.invalidateQueries(getAssemblyAssignment.getKey(projectId))
      client.invalidateQueries(getElementCrossSectionAssignment.getKey(projectId))
      invalidateResults(projectId as string)
      enqueueSnackbar('Platzierung der Wände erfolgreich verändert', { variant: 'success' })
    },
    onError: () => {
      enqueueSnackbar('Fehler beim Speichern der Wandplatzierung', { variant: 'error' })
    },
  })

  return (
    <Form2 onSubmit={state => mutate(state)} defaultValues={defaultValues}>
      <Stack direction="column" spacing={1} sx={{ width: '100%' }}>
        <Select
          label="Platzierung"
          name="placement"
          options={[
            {
              value: 'Internal',
              label: 'Intern',
            },
            {
              value: 'External',
              label: 'Extern',
            },
          ]}
          fullWidth
        />
        <Stack direction="row" flex={1}>
          <SubmitButton loading={isLoading} disableIfNotDirty={false} />
        </Stack>
      </Stack>
    </Form2>
  )
}

export default WallPlacement
